import * as Sentry from '@sentry/react';
import { Link } from 'react-router-dom';
import { ReactNode } from 'react';

interface SentryErrorBoundaryProps {
  children: ReactNode;
  showError?: boolean;
}

export const SentryErrorBoundary = ({ children }: SentryErrorBoundaryProps) => {
  return (
    <Sentry.ErrorBoundary
      fallback={() => {
        return (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Something went wrong</h2>
            <div style={{ marginTop: '20px' }}>
              <Link to="/">Go to home page</Link>
            </div>
          </div>
        );
      }}
      showDialog
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};
